/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Text, Tooltip } from '@blend/enterprise-components';
import { StyleSheet, css } from 'aphrodite';
import { enterpriseColors } from '../../../../src/style/colors';
import { NotaryAPI } from '../../../../src/api/notary/types';
import { formatFullName, titleCase } from '@utils/formatting';

const styles = StyleSheet.create({
  additionalSigners: {
    backgroundColor: enterpriseColors.NEUTRAL_200,
    padding: '4px',
  },
});

export const SignerCell: React.FC<{ value: NotaryAPI.Signer[] }> = ({ value }) => {
  const getSignersDisplay = () => {
    let primarySigner;
    const filteredSigners = [
      ...new Set(
        value.map(signer => {
          if (signer.title === 'Primary Borrower') {
            primarySigner = formatFullName(signer);
          }
          return titleCase(formatFullName(signer));
        }),
      ),
    ];
    const allSigners = filteredSigners.join(', ');
    if (!primarySigner && value.length > 0) {
      primarySigner = formatFullName(value[0]);
    }
    const additionalNumber = filteredSigners.length - 1;
    const shouldShowTooltip = additionalNumber > 0;
    return {
      allSigners,
      primarySigner,
      additionalNumber,
      shouldShowTooltip,
    };
  };

  const { allSigners, primarySigner, additionalNumber, shouldShowTooltip } = getSignersDisplay();
  return (
    <Text>
      {shouldShowTooltip ? (
        <Tooltip position="bottom" size="sm" text={allSigners}>
          <Text>
            {titleCase(primarySigner)} <span className={css(styles.additionalSigners)}>+{additionalNumber}</span>
          </Text>
        </Tooltip>
      ) : (
        <Text>{titleCase(primarySigner)}</Text>
      )}
    </Text>
  );
};
